import { InputField } from "components/InputField/Input";
import { CommonButton } from "components/Buttons/Buttons";
import { BiMinus, BiPlus } from "react-icons/bi";
import useItemDropdown from "./useItemDropdown";
import { dropdownFunction } from "utilities/dropdownFunction";

const useProductDataTable = (formik, setDeleteProductID, setShowDeleteProductModal) => {
    const addProductOnChange = (e, i, fieldName) => {
        formik.setFieldValue(`requisition_items[${i}].${fieldName}`, e?.value || e?.target?.value);
    };

    const { productDropdown, setProductDropdown, productNameList} = useItemDropdown();

    const modalTableColumns = [
        {
            field: "product",
            header: "Item",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="product"
                        name="product"
                        autoFilteredValue={productDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setProductDropdown, productNameList)}
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "product")}
                        value={formik.values.requisition_items[event.rowIndex]?.product}
                        type="select"
                        label="Select Item"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        errors={formik.errors.requisition_items?.[event.rowIndex]?.product?.id}
                    />
                </div>
            ),
        },
        {
            field: "stock_quantity",
            header: "Stock Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="stock_quantity"
                        name="stock_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "stock_quantity")}
                        value={formik.values.requisition_items[event.rowIndex]?.product?.stock_quantity}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="stock_quantity"
                        required={true}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.requisition_items?.[event.rowIndex]?.product?.stock_quantity}
                    />
                </div>
            ),
        },
        {
            field: "order_quantity",
            header: "Order Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="order_quantity"
                        name="order_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "order_quantity")}
                        value={formik.values.requisition_items[event.rowIndex]?.order_quantity}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="order_quantity"
                        required={true}
                        messagePosition='bottom'
                        errors={formik.errors.requisition_items?.[event.rowIndex]?.order_quantity}
                    />
                </div>
            ),
        },
        {
            field: "remark",
            header: "Remark",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="remark"
                        name="remark"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "remark")}
                        value={formik.values.requisition_items[event.rowIndex]?.remark}
                        type="text"
                        width="full"
                        autoCompleteFieldName="remark"
                        required={false}
                        messagePosition='bottom'
                        errors={formik.errors.requisition_items?.[event.rowIndex]?.remark}
                    />
                </div>
            ),
        },
    ]

    const deleteRequisitionItems = (rowData) => {
        const {id, requisition} = rowData;
        setDeleteProductID({id, requisition})
        setShowDeleteProductModal(true)
    }

    const modalTableActionButton = (rowData, {rowIndex}) => {
        const handleOnFieldIncrement = () => {
            const joinData = formik.values.requisition_items.concat({
                fieldId: rowIndex + 1,
                product: "",
                stock_quantity: "",
                required_quantity: "",
                remark: "",
            });
            formik.setFieldValue("requisition_items", joinData)
        };

        const handleOnFieldDecrement = (i) => {
            if(rowData.id > 0){
                return deleteRequisitionItems(rowData)
            }
            const removeData = [...formik.values.requisition_items];
            removeData.splice(rowIndex, 1);
            formik.setFieldValue("requisition_items", removeData);
        };

        return (
            <>
                <div className="flex items-center justify-center">
                    {
                        formik.values.requisition_items.length - 1 === rowIndex ? (
                            <>
                                <CommonButton 
                                    icon={<BiPlus className="text-green-700 text-2xl" />}
                                    className="p-button-rounded p-mr-2 action-button-green"
                                    title=""
                                    type="button"
                                    onClick={handleOnFieldIncrement}
                                />
                                {formik.values.requisition_items.length !== 1 && 
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />}
                            </>
                        ) : 
                        (
                            <>
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />
                            </>
                        )
                    }
                </div>
            </>
        )
    }

    return {
        modalTableColumns,
        modalTableActionButton,
    }
}

export default useProductDataTable